import React, { useState, useEffect, useCallback } from "react";
import PT from "prop-types";
import Modal from "./";
import { connect, useStore } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { localStoragePersistor } from "@/utils/persistors";
import { wait } from "@/utils";
import { steps as allSteps } from "./config";
import { ENABLE_MASTER_INITIAL_SETUP } from "@/config";

const connector = connect((state) => ({
  masterId: UserSelectors.getMasterId(state),
  isStandardMode: UserSelectors.isStandardMode(state),
  isSaloonOwnerOrAdmin: UserSelectors.isSaloonOwnerOrAdmin(state),
}));
const PERSIST_DOMAIN = "SKIP_MASTER_USER_INITIAL_SETUP::";
const GlobalMasterUserInitialSetupModal = ({
  masterId,
  isStandardMode,
  isSaloonOwnerOrAdmin,
}) => {
  const [skipSteps, setSkipSteps] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const onClose = useCallback(() => {
    setIsOpen(false);
    setSkipSteps([]);
    localStoragePersistor.set(PERSIST_DOMAIN + masterId, true);
  }, [masterId]);
  const store = useStore();
  useEffect(() => {
    async function foo() {
      if (
        !masterId ||
        isStandardMode ||
        isSaloonOwnerOrAdmin ||
        !ENABLE_MASTER_INITIAL_SETUP
      )
        return;

      await wait(500);
      const shouldSkip = localStoragePersistor.get(PERSIST_DOMAIN + masterId);
      if (shouldSkip) return;
      const state = store.getState();
      const master = UserSelectors.getMaster(state);
      // shouldn't be here
      if (!master) return;
      const hasServices = UserSelectors.hasServices(state);
      // better to check location field (which contains actual user coordinates) but this should do the trick
      const hasLocation = !!UserSelectors.getMasterLocationHr(state);
      const stepsToSkip = [
        hasServices && "service",
        hasLocation && "location",
      ].filter(Boolean);
      // all steps completed
      if (stepsToSkip.length === allSteps.length) {
        onClose();
        return;
      } else {
        setSkipSteps(stepsToSkip);
        setIsOpen(true);
      }
    }
    foo();
  }, [masterId, isStandardMode, onClose, isSaloonOwnerOrAdmin]);
  if (!masterId) return null;
  return <Modal skipSteps={skipSteps} isOpen={isOpen} onClose={onClose} />;
};
GlobalMasterUserInitialSetupModal.propTypes = {
  masterId: PT.string,
  isStandardMode: PT.bool,
  isSaloonOwnerOrAdmin: PT.bool,
};
export default connector(GlobalMasterUserInitialSetupModal);
